//imports
import React from 'react';
import { Link, Route, Switch } from 'react-router-dom';
import { withRouter } from 'react-router-dom';
import compose from 'recompose/compose';
//views
//create - event
import AllEvents from './AllEvents/index'; //pg1
import SubEvents from './CreateNewEvent/AllSubEvents/index'; //pg3
import CreateSubEvents from './CreateNewEvent/SubEvent/index';
import Seats from './Seats/index';
import * as actionCreator from "../../../../store/Action";
import {connect} from "react-redux"; //pg4
import { useLocation } from 'react-router-dom'
import $ from "jquery";
//css
import './Styles.css';
//inner routes
import * as innerRoutes from './InnerRoutes/InnerRoutes';
//modify - event

//external functions

//class
class App extends React.Component {

  goBack = () => {
    this.props.history.goBack()
  };

  push_all_events = () => {
    let strings = (window.location.pathname).split("/");
    let string = strings[1];
    if(string === "corporate") {
      this.props.history.push(innerRoutes.cor_inner_route_allEvents)
    } else {
      this.props.history.push(innerRoutes.inner_route_allEvents)
    }
  };

  push_sub_events = () => {
    let strings = (window.location.pathname).split("/");
    let string = strings[1];
    if(string === "corporate") {
      this.props.history.push(innerRoutes.cor_inner_route_event_sub_events)
    } else {
      this.props.history.push(innerRoutes.inner_route_event_sub_events)
    }
  };

  push_sub_event = () => {
    let strings = (window.location.pathname).split("/");
    let string = strings[1];
    if(string === "corporate") {
      this.props.history.push(innerRoutes.cor_inner_route_event_sub_events_sub_event)
    } else {
      this.props.history.push(innerRoutes.inner_route_event_sub_events_sub_event)
    }
  };

  push_events_event = () => {
    let strings = (window.location.pathname).split("/");
    let string = strings[1];
    if(string === "corporate") {
      this.props.history.push(innerRoutes.cor_inner_route_events_event)
    } else {
      this.props.history.push(innerRoutes.inner_route_events_event)
    }
  };

  push_sub_events_event = () => {
    let strings = (window.location.pathname).split("/");
    let string = strings[1];
    if(string === "corporate") {
      this.props.history.push(innerRoutes.cor_inner_route_event_sub_events_sub_event)
    } else {
      this.props.history.push(innerRoutes.inner_route_event_sub_events_sub_event)
    }
  };

  componentDidMount() {
    if(this.props.current_event == null) {this.push_all_events();}
  }

  componentDidUpdate() {
    window.onscroll = function() {
      if(window.pageYOffset >= 100) {
        $(".rapid-box-top-nav").css({"margin-top":"-66px", "position": "fixed", "z-index":"999"});
        // $(".rapid-box-top-nav").css({"margin-top":"-58px", "position": "fixed", "z-index":"999"});
      } else {
        $(".rapid-box-top-nav").css({"margin-top":"-20px","position": "relative"});
        // $(".rapid-box-top-nav").css({"margin-top":"-14px","position": "relative"});
      }
    };
  }

  componentWillUnmount() {
    window.onscroll = null;
  }

  render() {

    let view = <AllEvents/>;

    let location_tital = "";

    if(window.location.pathname === innerRoutes.inner_route_allEvents || window.location.pathname === innerRoutes.cor_inner_route_allEvents){

    }else if(window.location.pathname === innerRoutes.inner_route_event_sub_events || window.location.pathname === innerRoutes.cor_inner_route_event_sub_events){

    if(this.props.current_event !== null) {
      location_tital = <div className="nav-title set-pointer">
        <span onClick={this.push_all_events}>Events</span><span className={'span-padding'}> / </span>
        <span onClick={this.push_sub_events}>{this.props.current_event.event_name}</span>
      </div>

    } else {
      location_tital = "";
      if(this.props.current_event == null) {this.push_all_events();}
    }

    }else if(window.location.pathname === innerRoutes.inner_route_event_sub_events_sub_event || window.location.pathname === innerRoutes.cor_inner_route_event_sub_events_sub_event) {
      if(this.props.current_sub_event_id === '' || this.props.current_sub_events.length === 0) {
        if(this.props.current_event !== null) {
        location_tital = <div className="nav-title set-pointer">
          <span onClick={this.push_all_events}>Events</span><span className={'span-padding'}> / </span>
          <span onClick={this.push_sub_events}>{this.props.current_event.event_name} <span className={'span-padding'}> / </span> Create New Sub Event</span>
        </div>} else {
          location_tital = "";
          if(this.props.current_event == null) {this.push_all_events();}
        }
      }else{
        if(this.props.current_event !== null) {
        location_tital = <div className="nav-title set-pointer">
          <span onClick={this.push_all_events}>Events</span><span className={'span-padding'}> / </span>
          <span onClick={this.push_sub_events}>{this.props.current_event.event_name}</span><span> <span className={'span-padding'}> / </span> {this.props.current_sub_events[this.props.current_sub_event_id].name}</span>
      </div>} else {
          location_tital = "";
          if(this.props.current_event == null) {this.push_all_events();}
        }
      }
    }else if(window.location.pathname === innerRoutes.inner_route_events_event || window.location.pathname === innerRoutes.cor_inner_route_events_event){
      if(this.props.current_sub_event_id === '' || this.props.current_sub_events.length === 0) {
        location_tital = <div className="nav-title set-pointer">
          <span onClick={this.push_all_events}>Events</span><span className={'span-padding'}> / </span>
          <span onClick={this.push_events_event}>{this.props.current_event.event_name}</span>
        </div>
      }else{
        location_tital = <div className="nav-title set-pointer">
          <span onClick={this.push_all_events}>Events</span><span className={'span-padding'}> / </span>
          <span onClick={this.push_events_event}>{this.props.current_event.event_name}</span>
        </div>
      }
    } else if(window.location.pathname === innerRoutes.inner_route_events_event_seats || window.location.pathname === innerRoutes.cor_inner_route_events_event_seats) {
      if(this.props.current_sub_event_id === '' || this.props.current_sub_events.length === 0) {
        location_tital = <div className="nav-title set-pointer">
          <span onClick={this.push_all_events}>Events</span><span className={'span-padding'}> / </span>
          <span onClick={this.push_events_event}>{this.props.current_event.event_name}</span>
          <span> / Seats </span>
        </div>
      }else{
        location_tital = <div className="nav-title set-pointer">
          <span onClick={this.push_all_events}>Events</span><span className={'span-padding'}> / </span>
          <span onClick={this.push_events_event}>{this.props.current_event.event_name}</span>
          <span> / Seats </span>
        </div>
      }
    }else if(window.location.pathname === innerRoutes.inner_route_event_sub_events_sub_event_seats || window.location.pathname === innerRoutes.cor_inner_route_event_sub_events_sub_event_seats) {
      if (this.props.current_sub_event_id === '' || this.props.current_sub_events.length === 0) {
        location_tital = <div className="nav-title set-pointer">
          <span onClick={this.push_all_events}>Events</span><span className={'span-padding'}> / </span>
          <span onClick={this.push_events_event}>{this.props.current_event.event_name}</span>
          <span onClick={this.push_sub_events_event}> <span className={'span-padding'}> / </span> {this.props.current_sub_events[this.props.current_sub_event_id]!=undefined ? this.props.current_sub_events[this.props.current_sub_event_id].name : ""}</span>
          <span> / Seats</span>
        </div>
      } else {
        location_tital = <div className="nav-title set-pointer">
          <span onClick={this.push_all_events}>Events</span><span className={'span-padding'}> / </span>
          <span onClick={this.push_events_event}>{this.props.current_event.event_name}</span>
          <span onClick={this.push_sub_events_event}> <span className={'span-padding'}> / </span> {this.props.current_sub_events[this.props.current_sub_event_id]!=undefined ? this.props.current_sub_events[this.props.current_sub_event_id].name : ""}</span>
          <span> / Seats</span>
        </div>
      }
    }

    return(
      <div>
        {
          window.location.pathname !== innerRoutes.inner_route_allEvents && window.location.pathname !== innerRoutes.cor_inner_route_allEvents?
          <div className="rapid-box-top-nav">
            {(window.location.pathname !== "/eventtags/events" && window.location.pathname !== "/corporate/eventtags/events")?
              <i className="arrow left icon set-pointer" onClick={this.goBack}></i>
              :""}
            {location_tital}
          </div>:""
        }
        {/*{ view }*/}
        <Switch>
          <Route exact path={innerRoutes.inner_route_allEvents} component={AllEvents}/>
          <Route exact path={innerRoutes.inner_route_event_sub_events} component={SubEvents}/>
          <Route exact path={innerRoutes.inner_route_event_sub_events_sub_event} component={CreateSubEvents}/>
          <Route path={innerRoutes.inner_route_event_sub_events_sub_event_seats} component={Seats}/>
          <Route exact path={innerRoutes.inner_route_events_event} component={CreateSubEvents}/>
          <Route path={innerRoutes.inner_route_events_event_seats} component={Seats}/>

          <Route exact path={innerRoutes.cor_inner_route_allEvents} component={AllEvents}/>
          <Route exact path={innerRoutes.cor_inner_route_event_sub_events} component={SubEvents}/>
          <Route exact path={innerRoutes.cor_inner_route_event_sub_events_sub_event} component={CreateSubEvents}/>
          <Route path={innerRoutes.cor_inner_route_event_sub_events_sub_event_seats} component={Seats}/>
          <Route exact path={innerRoutes.cor_inner_route_events_event} component={CreateSubEvents}/>
          <Route path={innerRoutes.cor_inner_route_events_event_seats} component={Seats}/>
        </Switch>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  pg: state.eventReducer.pg,
  current_event: state.eventReducer.current_event,
  current_sub_events: state.eventReducer.current_sub_events,
  current_sub_event_id: state.eventReducer.current_sub_event_id,
  // usr obj
  usr_obj: state.userReducer.user,
});

const mapDispatchToProps = (dispatch) => {
  return {
    navigationChangeHandler: (data) => dispatch(actionCreator.navigationChangeHandler(data)),
    spinnerHandler: (data) => dispatch(actionCreator.spinnerHandler(data)),
  };
};

// export default connect(mapStateToProps, mapDispatchToProps)(App);
export default compose(withRouter, connect(mapStateToProps, mapDispatchToProps))(App);

